import { render, staticRenderFns } from "./_CustomerItem.vue?vue&type=template&id=4fe7384a&"
import script from "./_CustomerItem.vue?vue&type=script&lang=js&"
export * from "./_CustomerItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports